import {BookingRestriction} from "../types";
import {capacityIsBookable} from "../bookingRestriction";

export type CalendarDayOption = {
    optionId: string;
    availableSlots: number;
}
export class ExperienceCalendarDay {
    date: Date;
    options: CalendarDayOption[];
    restriction: BookingRestriction;
    constructor(
        date: Date,
        options: CalendarDayOption[],
        restriction: BookingRestriction
    ) {
        this.date = date;
        this.options = options;
        this.restriction = restriction;
    }
    get totalAvailableSlots(): number {
        return this.options.reduce((acc, option) => acc + option.availableSlots, 0);
    }
    get totalOptions(): number {
        return this.options.length;
    }
    get hasAvailableSlots(): boolean {
        return this.bookableOptions.length > 0;
    }
    get bookableOptions(): CalendarDayOption[] {
        return this.options.filter(option => capacityIsBookable(option.availableSlots, this.restriction));
    }
}